import {useEffect, useState} from 'react'
import {Col, Image, Row} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import ChangePassword from './ChangePassword'
import {useAuth, getAuth, removeAuth} from '../../auth'

export function UpdatePassword() {
  const [success, setSuccess] = useState(false)
  const [failToDetectAuth, setFailToDetectAuth] = useState(false)
  const navigate = useNavigate()
  const {logout} = useAuth()

  const handleOnCancel = () => {
    logout()
    navigate('/auth/login')
  }

  const handleOnSuccess = () => {
    setSuccess(true)
    logout()
  }

  const handleNoActiveAuth = () => {
    setFailToDetectAuth(true)
  }

  useEffect(() => {
    if (failToDetectAuth) navigate('/auth/login')
  }, [failToDetectAuth])

  return (
    <div className='w-100 mw-450px h-100 d-flex flex-center'>
      <Row className='g-10'>
        {success && (
          <>
            <Col xs={12} className='text-center'>
              <Image className='h-100px mb-4' src={toAbsoluteUrl('/media/auth/ok_w.png')} />
              <div className='separator separator-content mt-4 mb-6'>
                <h2 className='text-gray-900 fs-1 text-nowrap'>Password Updated Successfully</h2>
              </div>
            </Col>
            <Col xs={12} className='text-center'>
              <p>
                Your password has been changed successfully. You can now{' '}
                <Link to='/auth/login' className='fw-bold'>
                  login
                </Link>{' '}
                using your new password.
              </p>
            </Col>
          </>
        )}
        <ChangePassword
          show={!success}
          showSpinner={true}
          onSuccessSave={handleOnSuccess}
          onCancel={handleOnCancel}
          subMessage='Your password has expired, you must change your password now in order to use the system.'
          keepCurrentAuthAlive={false}
          onFailedDetectCurrentAuth={handleNoActiveAuth}
        />
      </Row>
    </div>
  )
}
